/**
 * @author Mihail Sablin <mihail@webprogrammist.com>
 * @copyright Copyright (c) 2023, Mihail Sablin
 * @licence http://www.opensource.org/licenses/mit-license.php MIT licence
 */
;
"use strict";

/**
 * Видимость полей формы в зависимости от значения других полей
 */
(function() {

	var defaults = {
		groupSelector: '.form-group',
		modelName: null,
		defaultAction: 'visible',
	};

	/**
	 * @param {jQuery|String} element Form element selector
	 * @param {Object} options
	 * @constructor
	 */
	function Plugin(element, options) {
		this.el = element;
		this.$el = $(element);
		this.tracked = [];
		this.depended = {};
		this.configs = {};
		this.options = $.extend({}, defaults, options);
		this.init();
	}

	Plugin.prototype.init = function() {

		let self = this;
		let fields = this.$el.find('[data-visibility]');
		let tracked = this.tracked;
		let depended = this.depended;
		let configs = this.configs;
		// обходим зависимые поля
		fields.each(function(i, v) {
			let data = $(v).data('visibility');
			if(data) {
				let name = self.extractName($(v).attr('name'));
				if(data.fields) {
					let action = data.action || self.options.defaultAction;
					// обходим поля, от которых зависит данное поле
					jQuery.each(data.fields, function(fName, values) {
						tracked.push(fName);
						if(!depended[fName]) {
							depended[fName] = [];
						}
						depended[fName].push(name);
					});
					configs[name] = {fields: data.fields, action: action, trigger: !!data['trigger']};
				}
			}
		});
		if(tracked) {
			tracked = tracked.filter((v, i, a) => a.indexOf(v) === i);
			jQuery.each(tracked, function(i, v) {
				let fieldName = self.fieldName(v);
				self.$el.find('[name="' + fieldName + '"]').on('change', self.handler());
			});
			jQuery.each(tracked, function(i, v) {
				let fieldName = self.fieldName(v);
				self.$el.find('[name="' + fieldName + '"]').trigger('change');
			});
		}
	};

	/**
	 * @returns {(function(*): void)|*}
	 */
	Plugin.prototype.handler = function() {
		let self = this;
		return function(evt) {
			let name = $(this).attr('name');
			name = self.extractName(name);
			let depended = self.depended[name];
			depended.forEach(function(v, i, c) {
				let conf = self.configs[v];
				let result = true;
				let keys = Object.keys(conf.fields);
				keys.forEach(function(v) {
					let fName = self.fieldName(v);
					let element = $('[name="' + fName + '"]');
					let val = element.val();
					if(~conf.fields[v].indexOf(val)) {
						result &= true;
					} else {
						result &= false;
					}
				});
				let selector = '[name="' + self.fieldName(v) + '"]';
				let mode, query;
				if(result) {
					if(conf.action === 'visible') {
						query = self.options.groupSelector ? $(selector).parents(self.options.groupSelector) : $(selector);
						mode = true;
					} else {
						query = self.options.groupSelector ? $(selector).parents(self.options.groupSelector) : $(selector);
						mode = false;
					}
				} else {
					if(conf.action === 'visible') {
						query = self.options.groupSelector ? $(selector).parents(self.options.groupSelector) : $(selector);
						mode = false;
					} else {
						query = self.options.groupSelector ? $(selector).parents(self.options.groupSelector) : $(selector);
						mode = true;
					}
				}
				query.toggle(mode);
				if(mode && $.isFunction(self.options.onShow)) {
					self.options.onShow(selector, query);
				} else if(!mode && $.isFunction(self.options.onHide)) {
					self.options.onHide(selector, query);
				}
				if($.isFunction(self.options.onToggle)) {
					self.options.onToggle(selector, query, mode);
				}
				if(conf.trigger) {
					$(selector).trigger('change');
				}
			});
		}
	};

	Plugin.prototype.fieldName = function(name) {
		return this.options.formName + '[' + name + ']';
	};

	Plugin.prototype.extractName = function(name) {
		let rx = new RegExp("^" + this.options.formName + '\\[(.*)\\]', 'u');
		let res = rx.exec(name);
		return res[1];
	};

	$.fn.visibilityControl = function(options) {
		return this.each(function() {
			if(!$.data(this, 'visibilityControl')) {
				$.data(this, 'visibilityControl', new Plugin(this, options));
			} else {
				try {
					$(this).data('visibilityControl').init();
				} catch(err) {
					console.error('visibilityControl has not initiated properly', err);
				}
			}
		});
	};

})();
